/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable unused-imports/no-unused-vars */
import React, { useEffect, useMemo, useState, useRef } from 'react';
import {
  Box,
  MenuItem,
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControlLabel,
  Tabs,
  Tab,
  AccordionProps,
  styled,
  Divider,
  IconButton,
  Chip,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Slider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import MergeIcon from '@mui/icons-material/MergeType';
import SplitIcon from '@mui/icons-material/CallSplit';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ColorPickerInput from '@/components/color-picker-input/color-picker-input';
import TextField from '@/components/text-field/text-field';
import Select from '@/components/select/select';
import formatText from '@/utils/format-text';
import Typography from '@/components/typography/typography';
import Android12Switch from '@/components/switches/android-12-switch';
import BorderControl from './border-control';
import Button from '@/components/button/button';
import Checkbox from '@/components/checkbox/checkbox';
import { Trash } from '@/components/icons';
import SearchableSelect from '@/components/searchable-select';

// Type definitions
interface TableColumn {
  id: string;
  header: string;
  align?: string;
  width?: string;
}

interface TableRow {
  [key: string]: string;
}

interface CellMerge {
  section: 'thead' | 'tbody';
  rowStart: number;
  rowEnd: number;
  colStart: number;
  colEnd: number;
  value: string;
}

interface HeaderCell {
  id: string;
  value: string;
}

interface HeaderRow {
  id: string;
  cells: HeaderCell[];
}

interface TableData {
  columns: TableColumn[];
  rows: TableRow[];
  mergedCells?: CellMerge[];
  headerRows?: HeaderRow[];
  cellStyles?: {
    thead?: { [rowIndex: number]: { [colIndex: number]: React.CSSProperties } };
    tbody?: { [rowIndex: number]: { [colId: string]: React.CSSProperties } };
  };
}

const Accordion = styled(
  (props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  )
)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 0,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

interface TableControlsProps {
  tableData: TableData;
  setTableData: (value: TableData) => void;
  attrs: any;
  updateAttrs: (value: any) => void;
  placeholders: Record<string, any>[];
  handleSave?: () => void;
  setParentRowLevel?: (value: boolean) => void;
  levelType?: boolean;
  relation_table?: any;
}

const textAlignOptions = ['left', 'center', 'right', 'justify'];
const fontWeightOptions = ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'];
const fontFamilyOptions = [
  'Arial, sans-serif',
  'Helvetica, sans-serif',
  'Times New Roman, serif',
  'Georgia, serif',
  'Courier New, monospace',
  'Verdana, sans-serif',
  'Tahoma, sans-serif',
  'Trebuchet MS, sans-serif'
];

const TableControls: React.FC<TableControlsProps> = ({
  tableData,
  setTableData,
  attrs,
  updateAttrs,
  placeholders,
  handleSave,
  setParentRowLevel,
  levelType,
  relation_table
}) => {

  const [tabValue, setTabValue] = useState(0);
  const [expanded, setExpanded] = useState('tableBasic');
  const [autoPopulateEnabled, setAutoPopulateEnabled] = useState(attrs.autoPopulateEnabled !== false);
  const [mergeDialogOpen, setMergeDialogOpen] = useState(false);
  const [selectedCells, setSelectedCells] = useState<{ section: 'thead' | 'tbody', row: number, col: number }[]>([]);
  const [mergeValue, setMergeValue] = useState('');
  const [rowLevel, setRowLevel] = useState(false);
  const { placeholders: tPlaceholders } = attrs;
  const [customText, setCustomText] = useState<{ [rowIndex: number]: { [columnId: string]: string } }>({});
  const [rowPlaceholders, setRowPlaceholders] = useState<{ [rowIndex: number]: { [columnId: string]: string } }>({});
  // Initialize merged cells from attrs
  const mergedCells = tableData.mergedCells || [];
  const [isUpdating, setIsUpdating] = useState(false);

  // Cell Styling State
  const [cellStyleDialogOpen, setCellStyleDialogOpen] = useState(false);
  const [editingCellStyle, setEditingCellStyle] = useState<{ section: 'thead' | 'tbody', row: number, col: string | number } | null>(null);
  const [tempCellStyle, setTempCellStyle] = useState<React.CSSProperties>({});
  const [editingCellText, setEditingCellText] = useState('');

  const openCellStyleDialog = (section: 'thead' | 'tbody', row: number, col: string | number) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const existingStyle = tableData.cellStyles?.[section]?.[row]?.[col] || {};
    
    let cellText = '';
    let legacyWidth = '';

    if (section === 'thead') {
       if (tableData.headerRows && tableData.headerRows.length > 0) {
          cellText = tableData.headerRows[row]?.cells[col as number]?.value || '';
       } else {
          cellText = tableData.columns[col as number]?.header || '';
       }
       if (row === 0) {
          legacyWidth = tableData.columns[col as number]?.width || '';
       }
    } else {
       cellText = tableData.rows[row]?.[col as string] || '';
       // also check customText or placeholders if empty
       if (!cellText) {
          cellText = customText[row]?.[col as string] || rowPlaceholders[row]?.[col as string] || '';
       }
    }

    setEditingCellText(cellText);
    
    setTempCellStyle({
      ...existingStyle,
      width: existingStyle.width || legacyWidth || ''
    });
    setEditingCellStyle({ section, row, col });
    setCellStyleDialogOpen(true);
  };

  const saveCellStyle = () => {
    if (!editingCellStyle) return;
    const { section, row, col } = editingCellStyle;
    
    setTableData(prev => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const sectionStyles = prev.cellStyles?.[section] || {};
      const rowStyles = sectionStyles[row] || {};
      
      const newCellStyles = {
        ...prev.cellStyles,
        [section]: {
          ...sectionStyles,
          [row]: {
            ...rowStyles,
            [col]: tempCellStyle
          }
        }
      };
      
      return {
        ...prev,
        cellStyles: newCellStyles as any
      };
    });
    setCellStyleDialogOpen(false);
    setEditingCellStyle(null);
  };

  // Column reordering and swapping state
  const draggedIndexRef = useRef<number | null>(null);
  const [showSwapTool, setShowSwapTool] = useState(false);
  const [swapColA, setSwapColA] = useState('');
  const [swapColB, setSwapColB] = useState('');
  const [reorderColId, setReorderColId] = useState('');
  const [targetPosition, setTargetPosition] = useState<number>(1);
  const [draggedColIndex, setDraggedColIndex] = useState<number | null>(null);
  const [dragOverColIndex, setDragOverColIndex] = useState<number | null>(null);
  const [activeGrabIndex, setActiveGrabIndex] = useState<number | null>(null);

  const tableAttributes = useMemo(() =>
    placeholders || [],
    [placeholders]
  );
  // Initialize styles from attrs or use default styles
  const [tableStyles, setTableStyles] = useState(attrs?.styles || {
    is_bordered: true,
    border: 1,
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    borderCollapse: 'collapse',
    width: '100%',
    thCells: {
      padding: 8
    },
    tbCells: {
      padding: 8
    },
    tHead: {
      backgroundColor: 'rgba(245, 245, 245, 0.75)',
      color: '#333333',
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'left',
      rowHeight: 38,
      ...(attrs?.styles?.tHead || {})
    },
    tBody: {
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      color: '#333333',
      fontSize: 14,
      fontWeight: 'normal',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'left',
      rowHeight: 38,
      ...(attrs?.styles?.tBody || {})
    }
  });

  // Apply styles to attrs when tableStyles change
  useEffect(() => {
    updateAttrs({ styles: tableStyles });
  }, [JSON.stringify(tableStyles)]);

  // Auto-populate rows when placeholders change
  useEffect(() => {
    if (autoPopulateEnabled && (tPlaceholders || rowLevel)) {
      populateRowsWithPlaceholders();
    }
  }, [tPlaceholders, autoPopulateEnabled, rowLevel, rowPlaceholders]);

  // Generate unique column ID
  const generateColumnId = () => {
    const existingIds = tableData.columns.map(col => col.id);
    let counter = 1;
    while (existingIds.includes(`col${counter}`)) {
      counter++;
    }
    return `col${counter}`;
  };

  // Get placeholder value by key
  const getPlaceholderValue = (placeholderKey: string): string => {
    const placeholder = tableAttributes.find(p => p.value === placeholderKey || p.id === placeholderKey || p.field === placeholderKey);
    if (!placeholder) return `{{${placeholderKey}}}`;

    // Return the placeholder syntax for row-level mode
    if (rowLevel) {
      return `{{${placeholder.value}}}`;
    }

    // Return the actual value or a sample value if it's dynamic
    if (typeof placeholder.actualValue !== 'undefined') {
      return String(placeholder.actualValue);
    }

    // For dynamic placeholders, return a sample/preview value
    switch (placeholder.type) {
      case 'date':
        return new Date().toLocaleDateString();
      case 'datetime':
        return new Date().toLocaleString();
      case 'number':
        return '123';
      case 'currency':
        return '$1,234.56';
      case 'email':
        return 'example@domain.com';
      case 'phone':
        return '+1 (555) 123-4567';
      case 'url':
        return 'https://example.com';
      default:
        const key = placeholder.value || placeholder.id || placeholder.field;
        return `{{${key}}}` || placeholder.label;
    }
  };

  // Modified: Populate rows with placeholder values for both column and row level
  const populateRowsWithPlaceholders = () => {
    if (!tPlaceholders && !rowLevel) return;

    setTableData(prev => ({
      ...prev,
      name: '',
      rows: prev.rows.map((row, rowIndex) => {
        const updatedRow = { ...row };

        prev.columns.forEach(column => {
          let placeholderKey: string | undefined;

          // Priority: Row-level placeholders take precedence when rowLevel is true
          if (rowLevel && rowPlaceholders[rowIndex]?.[column.id]) {
            placeholderKey = rowPlaceholders[rowIndex][column.id];
          } else if (tPlaceholders?.[column.id]) {
            placeholderKey = tPlaceholders[column.id];
          }

          if (placeholderKey) {
            updatedRow[column.id] = getPlaceholderValue(placeholderKey);
            // Preserve static text in the _static field
            const staticText = customText[rowIndex]?.[column.id] || '';
            if (staticText) {
              updatedRow[`${column.id}_static`] = `${staticText} ${updatedRow[column.id]}`;
            }
          }
        });

        return updatedRow;
      })
    }));
    setIsUpdating(false);
  };

  // Check if a cell is merged or covered by a merge
  const getCellMergeInfo = (section: 'thead' | 'tbody', rowIndex: number, colIndex: number) => {
    const merge = mergedCells?.find(m =>
      m.section === section &&
      rowIndex >= m.rowStart && rowIndex <= m.rowEnd &&
      colIndex >= m.colStart && colIndex <= m.colEnd
    );

    if (!merge) return null;

    return {
      merge,
      isTopLeft: rowIndex === merge.rowStart && colIndex === merge.colStart,
      isCovered: !(rowIndex === merge.rowStart && colIndex === merge.colStart)
    };
  };

  // Check if cell is selected for merging
  const isCellSelected = (section: 'thead' | 'tbody', rowIndex: number, colIndex: number) => {
    return selectedCells.some(cell =>
      cell.section === section && cell.row === rowIndex && cell.col === colIndex
    );
  };

  // Toggle cell selection for merging
  const toggleCellSelection = (section: 'thead' | 'tbody', rowIndex: number, colIndex: number) => {
    const cellKey = { section, row: rowIndex, col: colIndex };
    const isSelected = isCellSelected(section, rowIndex, colIndex);

    if (isSelected) {
      setSelectedCells(prev => prev.filter(cell =>
        !(cell.section === section && cell.row === rowIndex && cell.col === colIndex)
      ));
    } else {
      // Prevent mixing header and body cells in the same merge
      const hasDifferentSection = selectedCells.some(cell => cell.section !== section);
      if (hasDifferentSection) {
        alert('Cannot select cells from both header and body for the same merge');
        return;
      }
      setSelectedCells(prev => [...prev, cellKey]);
    }
  };

  // Open merge dialog
  const openMergeDialog = () => {
    if (selectedCells.length < 2) {
      alert('Please select at least 2 cells to merge');
      return;
    }

    // Get value from first selected cell
    const firstCell = selectedCells[0];
    let firstCellValue = '';
    let customTextValue = '';

    if (firstCell.section === 'tbody') {
      const columnId = tableData.columns[firstCell.col]?.id;
      firstCellValue = tableData.rows[firstCell.row]?.[columnId] || '';
      if (rowLevel) {
        customTextValue = customText[firstCell.row]?.[columnId] || '';
      }
    } else {
      firstCellValue = tableData.columns[firstCell.col]?.header || '';
    }

    // Combine customText with cell value only in row-level mode
    const initialMergeValue = rowLevel && customTextValue
      ? `${customTextValue} ${firstCellValue}`.trim()
      : firstCellValue;

    setMergeValue(initialMergeValue);
    setMergeDialogOpen(true);
  };

  // Perform cell merge
  const mergeCells = () => {
    if (selectedCells.length < 2) return;

    const section = selectedCells[0].section;
    const rowIndices = selectedCells.map(cell => cell.row);
    const colIndices = selectedCells.map(cell => cell.col);

    const rowStart = Math.min(...rowIndices);
    const rowEnd = Math.max(...rowIndices);
    const colStart = Math.min(...colIndices);
    const colEnd = Math.max(...colIndices);

    // Check if selection forms a rectangle
    const expectedCells = (rowEnd - rowStart + 1) * (colEnd - colStart + 1);
    if (selectedCells.length !== expectedCells) {
      alert('Please select a rectangular area of cells to merge');
      return;
    }

    // Check for overlapping merges
    const hasOverlap = mergedCells.some(existing =>
      existing.section === section &&
      !(rowEnd < existing.rowStart || rowStart > existing.rowEnd ||
        colEnd < existing.colStart || colStart > existing.colEnd)
    );

    if (hasOverlap) {
      alert('Cannot merge cells that overlap with existing merged cells');
      return;
    }

    const newMerge: CellMerge = {
      section,
      rowStart,
      rowEnd,
      colStart,
      colEnd,
      value: mergeValue
    };

    setTableData(prev => ({
      ...prev,
      name: '',
      mergedCells: [...(prev.mergedCells || []), newMerge],
      columns: section === 'thead' ? prev.columns.map((col, index) =>
        index === colStart ? { ...col, header: mergeValue } : col
      ) : prev.columns
    }));

    setSelectedCells([]);
    setMergeValue('');
    setMergeDialogOpen(false);
  };

  // Split merged cell
  const splitMergedCell = (mergeIndex: number) => {
    const merge = mergedCells[mergeIndex];

    setTableData(prev => {
      const updatedRows = [...prev.rows];
      const updatedColumns = [...prev.columns];

      if (merge.section === 'tbody') {
        for (let row = merge.rowStart; row <= merge.rowEnd; row++) {
          for (let col = merge.colStart; col <= merge.colEnd; col++) {
            const columnId = prev.columns[col]?.id;
            if (columnId && updatedRows[row]) {
              updatedRows[row][columnId] = merge.value;
            }
          }
        }
      } else {
        if (updatedColumns[merge.colStart]) {
          updatedColumns[merge.colStart].header = merge.value;
        }
      }

      return {
        ...prev,
        rows: updatedRows,
        name: '',
        columns: updatedColumns,
        mergedCells: prev.mergedCells?.filter((_, index) => index !== mergeIndex) || []
      };
    });
  };

  // Add new column
  const addColumn = () => {
    const newColumnId = generateColumnId();
    const newColumn: TableColumn = {
      id: newColumnId,
      header: `Column ${tableData.columns.length + 1}`
    };

    setTableData(prev => ({
      ...prev,
      name: '',
      columns: [...prev.columns, newColumn],
      rows: prev.rows.map(row => ({
        ...row,
        [newColumnId]: ''
      })),
      mergedCells: prev.mergedCells?.map(merge => ({
        ...merge
      })) || []
    }));
  };

  // Remove column
  const removeColumn = (columnId: string) => {
    const columnIndex = tableData.columns.findIndex(col => col.id === columnId);

    setTableData(prev => ({
      ...prev,
      name: '',
      columns: prev.columns.filter(col => col.id !== columnId),
      rows: prev.rows.map(row => {
        const { [columnId]: removed, ...rest } = row;
        return rest;
      }),
      mergedCells: prev.mergedCells
        ?.filter(merge => !(merge.colStart <= columnIndex && merge.colEnd >= columnIndex))
        .map(merge => ({
          ...merge,
          colStart: merge.colStart > columnIndex ? merge.colStart - 1 : merge.colStart,
          colEnd: merge.colEnd > columnIndex ? merge.colEnd - 1 : merge.colEnd
        })) || []
    }));

    if (tPlaceholders && tPlaceholders[columnId]) {
      const updatedPlaceholders = { ...tPlaceholders };
      delete updatedPlaceholders[columnId];
      updateAttrs({ placeholders: updatedPlaceholders });
    }
  };

  // Update column header
  const updateColumnHeader = (columnId: string, newHeader: string) => {
    setTableData(prev => ({
      ...prev,
      columns: prev.columns.map(col =>
        col.id === columnId ? { ...col, header: newHeader } : col
      )
    }));
  };

  // Move column order (swap adjacent)
  const moveColumn = (index: number, direction: -1 | 1) => {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= tableData.columns.length) return;

    setTableData(prev => {
      const newColumns = [...prev.columns];
      const temp = newColumns[index];
      newColumns[index] = newColumns[targetIndex];
      newColumns[targetIndex] = temp;

      return {
        ...prev,
        name: '',
        columns: newColumns,
      };
    });
  };

  // Swap any two columns by ID
  const handleSwapColumns = (colAId: string, colBId: string) => {
    if (!colAId || !colBId || colAId === colBId) return;
    const indexA = tableData.columns.findIndex(c => c.id === colAId);
    const indexB = tableData.columns.findIndex(c => c.id === colBId);
    if (indexA === -1 || indexB === -1) return;

    setTableData(prev => {
      const newColumns = [...prev.columns];
      const temp = newColumns[indexA];
      newColumns[indexA] = newColumns[indexB];
      newColumns[indexB] = temp;

      return {
        ...prev,
        name: '',
        columns: newColumns,
      };
    });
  };

  // Move column to exact position (1-based position)
  const moveColumnToPosition = (fromIndex: number, toPosition: number) => {
    const toIndex = toPosition - 1;
    if (toIndex < 0 || toIndex >= tableData.columns.length || toIndex === fromIndex) return;

    setTableData(prev => {
      const newColumns = [...prev.columns];
      const [moved] = newColumns.splice(fromIndex, 1);
      newColumns.splice(toIndex, 0, moved);

      return {
        ...prev,
        name: '',
        columns: newColumns,
      };
    });
  };

  // Drag and drop column reordering (splice insertion into exact position)
  const handleDropColumn = (e: React.DragEvent, targetIndex: number) => {
    e.preventDefault();
    const fromIndexStr = e.dataTransfer.getData('text/plain');
    const fromIndex = draggedIndexRef.current !== null
      ? draggedIndexRef.current
      : (fromIndexStr !== '' ? parseInt(fromIndexStr, 10) : draggedColIndex);

    if (fromIndex !== null && fromIndex !== undefined && !isNaN(fromIndex) && fromIndex !== targetIndex) {
      setTableData(prev => {
        const newColumns = [...prev.columns];
        const [moved] = newColumns.splice(fromIndex, 1);
        newColumns.splice(targetIndex, 0, moved);

        return {
          ...prev,
          name: '',
          columns: newColumns,
        };
      });
    }
    draggedIndexRef.current = null;
    setDraggedColIndex(null);
    setDragOverColIndex(null);
    setActiveGrabIndex(null);
  };

  // Add Header Row
  const addHeaderRow = () => {
    const newHeaderRowId = `hr${Date.now()}`;
    const newHeaderRow: HeaderRow = {
      id: newHeaderRowId,
      cells: tableData.columns.map((c, i) => ({ id: `hc${Date.now()}${i}`, value: '' }))
    };

    setTableData(prev => {
      const headerRows = prev.headerRows && prev.headerRows.length > 0
        ? [...prev.headerRows, newHeaderRow]
        : [
            // Create first one from existing columns if there were none
            { id: `hr_def`, cells: prev.columns.map((c, i) => ({ id: `hc_def_${i}`, value: c.header })) },
            newHeaderRow
          ];

      return {
        ...prev,
        headerRows
      };
    });
  };

  // Remove Header Row
  const removeHeaderRow = (rowIndex: number) => {
    setTableData(prev => {
      if (!prev.headerRows) return prev;
      const newHeaderRows = prev.headerRows.filter((_, idx) => idx !== rowIndex);
      
      // If we are back to 1 or 0 rows, we can just clear headerRows and revert to columns
      if (newHeaderRows.length <= 1) {
        if (newHeaderRows.length === 1) {
           // Sync back to columns if possible
           const newCols = prev.columns.map((c, i) => ({ ...c, header: newHeaderRows[0].cells[i]?.value || '' }));
           return {
             ...prev,
             columns: newCols,
             headerRows: undefined,
             mergedCells: prev.mergedCells?.filter(m => m.section !== 'thead') || []
           };
        }
        return { ...prev, headerRows: undefined };
      }

      return {
        ...prev,
        headerRows: newHeaderRows,
        mergedCells: prev.mergedCells?.filter(m => !(m.section === 'thead' && m.rowStart <= rowIndex && m.rowEnd >= rowIndex)).map(m => ({
          ...m,
          rowStart: m.section === 'thead' && m.rowStart > rowIndex ? m.rowStart - 1 : m.rowStart,
          rowEnd: m.section === 'thead' && m.rowEnd > rowIndex ? m.rowEnd - 1 : m.rowEnd
        })) || []
      };
    });
  };

  // Update Header Cell Value
  const updateHeaderCellValue = (rowIndex: number, colIndex: number, value: string) => {
    setTableData(prev => {
      if (!prev.headerRows) return prev;
      const newHeaderRows = [...prev.headerRows];
      newHeaderRows[rowIndex] = {
        ...newHeaderRows[rowIndex],
        cells: newHeaderRows[rowIndex].cells.map((c, idx) => idx === colIndex ? { ...c, value } : c)
      };
      
      const mergeInfo = getCellMergeInfo('thead', rowIndex, colIndex);
      let newMergedCells = prev.mergedCells || [];
      if (mergeInfo) {
        newMergedCells = newMergedCells.map(m => m === mergeInfo.merge ? { ...m, value } : m);
      }

      return {
        ...prev,
        headerRows: newHeaderRows,
        mergedCells: newMergedCells
      };
    });
  };

  // Add new row
  const addRow = () => {
    const newRow: TableRow = {};

    tableData.columns.forEach(col => {
      if (tPlaceholders?.[col.id]) {
        const placeholderKey = tPlaceholders[col.id];
        newRow[col.id] = `{{${placeholderKey}}}`;
        if (rowLevel) {
          newRow[`${col.id}_static`] = newRow[col.id];
        }

      } else if (tableData.rows.length > 0) {
        // Copy first row's data if no placeholder
        newRow[col.id] = tableData.rows[0][col.id] || '';
        if (rowLevel) {
          newRow[`${col.id}_static`] = tableData.rows[0][`${col.id}_static`] || ''
        }
      } else {
        // Default to empty
        if (rowLevel) {
          newRow[`${col.id}_static`] = '';
        }
        newRow[col.id] = '';
      }
    });

    setTableData(prev => {
      const updatedRows = [...prev.rows, newRow];
      return {
        ...prev,
        rows: updatedRows,
        name: '',
        mergedCells: prev.mergedCells?.map(merge => ({ ...merge })) || []
      };
    });
    handleSave?.();
  };

  // Remove row
  const removeRow = (rowIndex: number) => {
    setTableData(prev => ({
      ...prev,
      name: '',
      rows: prev.rows.filter((_, index) => index !== rowIndex),
      mergedCells: prev.mergedCells
        ?.filter(merge => !(merge.section === 'tbody' && merge.rowStart <= rowIndex && merge.rowEnd >= rowIndex))
        .map(merge => ({
          ...merge,
          rowStart: merge.section === 'tbody' && merge.rowStart > rowIndex ? merge.rowStart - 1 : merge.rowStart,
          rowEnd: merge.section === 'tbody' && merge.rowEnd > rowIndex ? merge.rowEnd - 1 : merge.rowEnd
        })) || []
    }));

    // Clean up rowPlaceholders and customText for the removed row
    setRowPlaceholders(prev => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
    setCustomText(prev => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
  };

  // Modified: Update cell value and trigger placeholder population
  const updateRowCellValue = (rowIndex: number, columnId: string, value: string) => {
    setIsUpdating(true);
    const colIndex = tableData.columns.findIndex(col => col.id === columnId);
    const mergeInfo = getCellMergeInfo('tbody', rowIndex, colIndex);
    const staticText = rowLevel ? (customText[rowIndex]?.[columnId] || '') : '';

    if (mergeInfo) {
      setTableData(prev => ({
        ...prev,
        name: '',
        mergedCells: prev.mergedCells?.map(merge =>
          merge === mergeInfo.merge ? { ...merge, value } : merge
        ) || []
      }));
    } else {
      if (rowLevel && value) {
        setRowPlaceholders(prev => {
          const updated = { ...prev };
          if (!updated[rowIndex]) {
            updated[rowIndex] = {};
          }
          updated[rowIndex][columnId] = value;
          return updated;
        });
      } else if (rowLevel && !value) {
        setRowPlaceholders(prev => {
          const updated = { ...prev };
          if (updated[rowIndex]?.[columnId]) {
            delete updated[rowIndex][columnId];
            if (Object.keys(updated[rowIndex]).length === 0) {
              delete updated[rowIndex];
            }
          }
          return updated;
        });
      }

      setTableData(prev => ({
        ...prev,
        name: '',
        rows: prev.rows.map((row, idx) =>
          idx === rowIndex ? {
            ...row,
            [columnId]: rowLevel ? (value ? `{{${value}}}` : '') : (value ? getPlaceholderValue(value) : ''),
            [`${columnId}_static`]: staticText ? `${staticText} ${value ? getPlaceholderValue(value) : ''}`.trim() : (value ? getPlaceholderValue(value) : '')
          } : row
        )
      }));

      populateRowsWithPlaceholders();
    }
  };
  const updateCellValue = (rowIndex: number, columnId: string, value: string) => {
    setIsUpdating(true);
    const colIndex = tableData.columns.findIndex(col => col.id === columnId);
    const mergeInfo = getCellMergeInfo('tbody', rowIndex, colIndex);
    const staticText = customText[rowIndex]?.[columnId] || '';

    if (mergeInfo) {
      setTableData(prev => ({
        ...prev,
        name: '',
        mergedCells: prev.mergedCells?.map(merge =>
          merge === mergeInfo.merge ? { ...merge, value } : merge
        ) || []
      }));
    } else {
      if (rowLevel) {
        setRowPlaceholders(prev => {
          const updated = { ...prev };
          if (!updated[rowIndex]) {
            updated[rowIndex] = {};
          }
          if (value) {
            updated[rowIndex][columnId] = value;
          } else {
            delete updated[rowIndex][columnId];
            if (Object.keys(updated[rowIndex]).length === 0) {
              delete updated[rowIndex];
            }
          }
          return updated;
        });
      }

      setTableData(prev => ({
        ...prev,
        name: '',
        rows: prev.rows.map((row, idx) =>
          idx === rowIndex ? {
            ...row,
            [columnId]: rowLevel ? (value ? `{{${value}}}` : '') : value,
            [`${columnId}_static`]: staticText ? `${staticText} ${value || ''}`.trim() : (value || '')
          } : row
        )
      }));

      if (rowLevel || (autoPopulateEnabled && tPlaceholders?.[columnId])) {
        populateRowsWithPlaceholders();
      }
      setIsUpdating(false);
    }
  };

  // Modified: Update column placeholder
  const updateColumnPlaceholder = (columnId: string, placeholderValue: string) => {
    setIsUpdating(true);
    const updatedPlaceholders = {
      ...tPlaceholders,
      [columnId]: placeholderValue
    };

    if (!placeholderValue) {
      delete updatedPlaceholders[columnId];
    }

    updateAttrs({ placeholders: updatedPlaceholders });

    if (autoPopulateEnabled) {
      const newCellValue = placeholderValue ? getPlaceholderValue(placeholderValue) : '';
      setTableData(prev => ({
        ...prev,
        name: '',
        rows: prev.rows.map(row => ({
          ...row,
          [columnId]: newCellValue
        }))
      }));
    }
    setIsUpdating(false);
  };

  // Refresh all rows with current placeholder values
  const refreshPlaceholderData = () => {
    populateRowsWithPlaceholders();
  };

  // Get placeholder info for display
  const getPlaceholderInfo = (placeholderKey: string) => {
    const placeholder = placeholders.find(p => p.value === placeholderKey);
    return placeholder ? {
      label: placeholder.label,
      type: placeholder.type || 'text',
      description: placeholder.description || ''
    } : null;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : '');
  };

  const updateTableStyle = (key: string, value: any) => {
    setTableStyles(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const updateHeaderStyle = (key: string, value: any) => {
    setTableStyles(prev => ({
      ...prev,
      tHead: {
        ...prev.tHead,
        [key]: value
      }
    }));
  };

  const updateHeaderCellStyle = (key: string, value: any) => {
    setTableStyles(prev => ({
      ...prev,
      thCells: {
        ...prev.thCells,
        [key]: value
      }
    }));
  };

  const updateBodyStyle = (key: string, value: any) => {
    setTableStyles(prev => ({
      ...prev,
      tBody: {
        ...prev.tBody,
        [key]: value
      }
    }));
  };

  const updateBodyCellStyle = (key: string, value: any) => {
    setTableStyles(prev => ({
      ...prev,
      tbCells: {
        ...prev.tbCells,
        [key]: value
      }
    }));
  };

  const resetTable = () => {
    setTableData((prev: TableData) => ({
      ...prev,
      name: '',
      rows: prev.rows.map((row: TableRow) => {
        return {
          ...Object.fromEntries(prev.columns.map((col: TableColumn) => [col?.id, '']))
        }
      })
    }));
  }
  // Count columns with placeholders
  const columnsWithPlaceholders = tPlaceholders ? Object.keys(tPlaceholders).length : 0;
  // Initialize rowLevel only once on mount (or when levelType changes externally)
  useEffect(() => {
    setRowLevel(!!levelType);
  }, [levelType]);

  // Update customText whenever tableData rows change
  useEffect(() => {
    setCustomText((prev: { [rowIndex: number]: { [columnId: string]: string } }) => {
      const updated: { [rowIndex: number]: { [columnId: string]: string } } = {};

      tableData.rows.forEach((row, rowIndex) => {
        Object.keys(row).forEach(columnId => {
          if (columnId.endsWith('_static')) {
            const originalColumnId = columnId.replace('_static', '');
            if (!updated[rowIndex]) {
              updated[rowIndex] = {};
            }

            const columnValue = row[originalColumnId] || '';
            let staticValue = row[columnId] || '';
            if (columnValue && staticValue.includes(columnValue)) {
              staticValue = staticValue.replace(columnValue, '').trim();
            }
            staticValue = staticValue.replace(/\{\{\s*value\s*\}\}/g, '').trim();
            updated[rowIndex][originalColumnId] = staticValue;
          }
        });
      });

      return updated;
    });
  }, [tableData]);

  useEffect(() => {
    setTableData(prev => {
      const newRows = prev.rows.length === 0 ? [{}] : prev.rows;

      return {
        ...prev,
        name: '',
        rows: newRows
      };
    });
  }, [autoPopulateEnabled]);
  // --- Calculate inherited styles for Cell Style Modal ---
  const inheritedDirection = tableStyles.direction || 'ltr';
  let inheritedBg = '';
  let inheritedColor = '';
  let inheritedAlign = '';
  let inheritedFontWeight = '';

  if (editingCellStyle?.section === 'thead') {
     inheritedBg = tableStyles.tHead?.backgroundColor ?? 'rgba(245, 245, 245, 0.75)';
     inheritedColor = tableStyles.tHead?.color || '#333333';
     inheritedAlign = tableStyles.tHead?.textAlign || 'left';
     inheritedFontWeight = tableStyles.tHead?.fontWeight || 'bold';
  } else if (editingCellStyle?.section === 'tbody') {
     inheritedBg = tableStyles.tBody?.backgroundColor ?? 'rgba(255, 255, 255, 0.75)';
     inheritedColor = tableStyles.tBody?.color || '#333333';
     const colData = tableData.columns.find(c => c.id === editingCellStyle.col);
     inheritedAlign = colData?.align === 'r' ? 'right' : colData?.align === 'c' ? 'center' : 'left';
     inheritedFontWeight = tableStyles.tBody?.fontWeight || 'normal';
  }

  return (
    <>
      <Box sx={{ mb: 2, borderBottom: 1, paddingBottom: 5, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth" sx={(theme) => ({
          '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.theme?.primary[700]
          },
          '& .MuiTab-root.Mui-selected': {
            color: theme.palette.theme?.primary[700],
          },
          '& .MuiTab-root': {
            textTransform: 'none'
          },
        })}>
          <Tab label="Content" />
          <Tab label="Styles" />
          <Tab label="Cell Merging" />
        </Tabs>
      </Box>

      {tabValue === 0 && (
        <>
          <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography type="s4" weight="medium" color="theme.primary.700">
                Dynamic Data Settings
              </Typography>
              <Chip
                label={`${columnsWithPlaceholders} columns linked`}
                size="small"
                color="primary"
                variant="outlined"
                sx={theme => ({
                  color: theme.palette.theme?.primary[700],
                  borderColor: theme.palette.theme?.primary[700]
                })}
              />
            </Box>

            <FormControlLabel
              control={
                <Android12Switch
                  checked={!!autoPopulateEnabled}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setAutoPopulateEnabled(checked);
                    updateAttrs({ autoPopulateEnabled: checked });
                  }}
                />
              }
              label={
                <Typography type="s5" color="theme.secondary.800">
                  Auto-populate rows with placeholder data
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Android12Switch
                  checked={!!rowLevel}
                  onChange={(e) => {
                    const isRowLevel = e.target.checked;
                    setRowLevel(isRowLevel);
                    setAutoPopulateEnabled(!isRowLevel);
                    setParentRowLevel?.(isRowLevel);

                    if (!isRowLevel) {
                      // Truncate to 1 row when disabling row-level management
                      setTableData(prev => ({
                        ...prev,
                        rows: prev.rows.length > 0 ? [prev.rows[0]] : [{}]
                      }));
                    }
                    resetTable();
                  }}
                />
              }
              label={
                <Typography type="s5" color="theme.secondary.800">
                  Row Level Management
                </Typography>
              }
            />

            {autoPopulateEnabled && (
              <Box sx={{ mt: 1.5 }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={refreshPlaceholderData}
                  startIcon={<RefreshIcon />}
                  className='black-outlined-btn'
                >
                  Refresh Data
                </Button>
              </Box>
            )}
          </Box>

          <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
              <Typography type="s3" weight="medium" color="theme.secondary.1000">
                Columns ({tableData.columns.length})
              </Typography>
              {tableData.columns.length > 1 && (
                <Button
                  variant="text"
                  size="small"
                  onClick={() => setShowSwapTool(!showSwapTool)}
                  startIcon={<SwapHorizIcon fontSize="small" />}
                  sx={{ textTransform: 'none', py: 0.25, px: 1, minWidth: 'auto', fontSize: '12px' }}
                >
                  {showSwapTool ? 'Hide Swap' : 'Swap / Reorder'}
                </Button>
              )}
            </Box>
            <Typography type="c1" color="text.secondary" sx={{ display: 'block', mb: 1, fontSize: '11px' }}>
              Drag ⠿ handle to reorder into position
            </Typography>

            {/* Quick Swap / Move to Position Panel */}
            {showSwapTool && tableData.columns.length > 1 && (
              <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f8fafc', borderRadius: 1.5, border: '1px solid #e2e8f0' }}>
                <Typography type="s5" weight="bold" color="theme.secondary.900" sx={{ mb: 1, display: 'block' }}>
                  Swap Two Columns
                </Typography>

                {/* 1. Swap two columns */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Select
                    size="small"
                    value={swapColA || tableData.columns[0]?.id || ''}
                    onChange={(e) => setSwapColA(e.target.value)}
                    sx={{ flex: 1, fontSize: '13px' }}
                  >
                    {tableData.columns.map((c, idx) => (
                      <MenuItem key={c.id} value={c.id}>
                        {idx + 1}. {c.header || `Col ${idx + 1}`}
                      </MenuItem>
                    ))}
                  </Select>
                  <SwapHorizIcon sx={{ color: '#64748b', fontSize: 20 }} />
                  <Select
                    size="small"
                    value={swapColB || tableData.columns[1]?.id || ''}
                    onChange={(e) => setSwapColB(e.target.value)}
                    sx={{ flex: 1, fontSize: '13px' }}
                  >
                    {tableData.columns.map((c, idx) => (
                      <MenuItem key={c.id} value={c.id}>
                        {idx + 1}. {c.header || `Col ${idx + 1}`}
                      </MenuItem>
                    ))}
                  </Select>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      const a = swapColA || tableData.columns[0]?.id;
                      const b = swapColB || tableData.columns[1]?.id;
                      handleSwapColumns(a, b);
                    }}
                    disabled={!tableData.columns || tableData.columns.length < 2 || (swapColA === swapColB && !!swapColA)}
                    sx={{ minWidth: 'auto', px: 1.5 }}
                  >
                    Swap
                  </Button>
                </Box>

                {/* 2. Move column to exact position */}
                <Divider sx={{ my: 1 }} />
                <Typography type="s5" weight="bold" color="theme.secondary.900" sx={{ mb: 1, display: 'block' }}>
                  Move Column To Position
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Select
                    size="small"
                    value={reorderColId || tableData.columns[tableData.columns.length - 1]?.id || ''}
                    onChange={(e) => setReorderColId(e.target.value)}
                    sx={{ flex: 1, fontSize: '13px' }}
                  >
                    {tableData.columns.map((c, idx) => (
                      <MenuItem key={c.id} value={c.id}>
                        {idx + 1}. {c.header || `Col ${idx + 1}`}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography type="s5" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                    to
                  </Typography>
                  <Select
                    size="small"
                    value={targetPosition || 1}
                    onChange={(e) => setTargetPosition(Number(e.target.value))}
                    sx={{ width: '70px', fontSize: '13px' }}
                  >
                    {tableData.columns.map((_, idx) => (
                      <MenuItem key={idx + 1} value={idx + 1}>
                        #{idx + 1}
                      </MenuItem>
                    ))}
                  </Select>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      const colId = reorderColId || tableData.columns[tableData.columns.length - 1]?.id;
                      const fromIdx = tableData.columns.findIndex(c => c.id === colId);
                      if (fromIdx !== -1) {
                        moveColumnToPosition(fromIdx, targetPosition);
                      }
                    }}
                    sx={{ minWidth: 'auto', px: 1.5 }}
                  >
                    Move
                  </Button>
                </Box>
              </Box>
            )}

            {tableData.columns?.map((column, index) => (
              <Box
                key={column.id}
                data-column-row="true"
                onDragOver={(e) => {
                  e.preventDefault();
                  e.dataTransfer.dropEffect = 'move';
                  if (dragOverColIndex !== index) {
                    setDragOverColIndex(index);
                  }
                }}
                onDragLeave={(e) => {
                  if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                    if (dragOverColIndex === index) {
                      setDragOverColIndex(null);
                    }
                  }
                }}
                onDrop={(e) => handleDropColumn(e, index)}
                sx={{
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  p: '3px 4px',
                  borderRadius: '6px',
                  bgcolor: dragOverColIndex === index && draggedColIndex !== index ? '#e0f2fe' : 'transparent',
                  border: dragOverColIndex === index && draggedColIndex !== index ? '1.5px dashed #0284c7' : '1.5px solid transparent',
                  opacity: draggedColIndex === index ? 0.35 : 1,
                  transition: 'all 0.15s ease',
                }}
              >
                <Box
                  draggable={true}
                  onDragStart={(e) => {
                    draggedIndexRef.current = index;
                    setDraggedColIndex(index);
                    e.dataTransfer.setData('text/plain', String(index));
                    e.dataTransfer.effectAllowed = 'move';
                    const rowEl = (e.currentTarget as HTMLElement).closest('[data-column-row]');
                    if (rowEl && e.dataTransfer.setDragImage) {
                      e.dataTransfer.setDragImage(rowEl, 20, 20);
                    }
                  }}
                  onDragEnd={() => {
                    draggedIndexRef.current = null;
                    setDraggedColIndex(null);
                    setDragOverColIndex(null);
                    setActiveGrabIndex(null);
                  }}
                  onMouseDown={() => setActiveGrabIndex(index)}
                  onMouseUp={() => setActiveGrabIndex(null)}
                  title="Drag to position"
                  sx={{
                    cursor: 'grab',
                    '&:active': { cursor: 'grabbing' },
                    display: 'flex',
                    alignItems: 'center',
                    color: '#94a3b8',
                    p: '2px',
                    userSelect: 'none',
                    '&:hover': { color: '#0f172a' },
                  }}
                >
                  <DragIndicatorIcon sx={{ fontSize: 18 }} />
                </Box>
                <TextField
                  label={`Column ${index + 1} Header`}
                  value={column.header}
                  onChange={(e) => updateColumnHeader(column.id, e.target.value)}
                  size="small"
                  sx={{
                    flex: 1,
                    pointerEvents: draggedColIndex !== null ? 'none' : 'auto',
                  }}
                />
                <IconButton
                  size="small"
                  onClick={() => moveColumn(index, -1)}
                  disabled={index === 0}
                  title="Move column left / up"
                  sx={{
                    p: 0.5,
                    color: index === 0 ? '#cbd5e1' : '#475569',
                    pointerEvents: draggedColIndex !== null ? 'none' : 'auto',
                  }}
                >
                  <KeyboardArrowUpIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => moveColumn(index, 1)}
                  disabled={index === tableData.columns.length - 1}
                  title="Move column right / down"
                  sx={{
                    p: 0.5,
                    color: index === tableData.columns.length - 1 ? '#cbd5e1' : '#475569',
                    pointerEvents: draggedColIndex !== null ? 'none' : 'auto',
                  }}
                >
                  <KeyboardArrowDownIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => removeColumn(column.id)}
                  disabled={tableData.columns.length <= 1}
                  color="error"
                  title="Delete column"
                  sx={{
                    p: 0.5,
                    pointerEvents: draggedColIndex !== null ? 'none' : 'auto',
                  }}
                >
                  <Trash />
                </IconButton>
              </Box>
            ))}
            <Button
              variant="outlined"
              size="small"
              onClick={addColumn}
              startIcon={<AddIcon />}
              sx={{ mt: 1 }}
              className='black-outlined-btn'
            >
              Add Column
            </Button>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography type="s3" weight="medium" color="theme.secondary.1000">
                Header Rows ({tableData.headerRows?.length || 1})
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={addHeaderRow}
                startIcon={<AddIcon />}
                className='black-outlined-btn'
              >
                Add Header Row
              </Button>
            </Box>

            {(tableData.headerRows && tableData.headerRows.length > 0
              ? tableData.headerRows
              : [{ id: 'default', cells: tableData.columns.map(c => ({ id: c.id, value: c.header })) }]
            ).map((hRow, rowIndex) => (
              <Box key={hRow.id} sx={{ mb: 2, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography type="s4" weight="medium" color="theme.secondary.800">
                    Header Row {rowIndex + 1}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => removeHeaderRow(rowIndex)}
                    disabled={(tableData.headerRows?.length || 1) <= 1}
                    color="error"
                  >
                    <Trash />
                  </IconButton>
                </Box>
                <Grid container spacing={1}>
                  {hRow.cells.map((cell, colIndex) => {
                    const mergeInfo = getCellMergeInfo('thead', rowIndex, colIndex);
                    
                    return (
                      <Grid item xs={12} key={cell.id}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <TextField
                            label={`Header Col ${colIndex + 1}`}
                            value={mergeInfo ? mergeInfo.merge.value : cell.value}
                            onChange={(e) => updateHeaderCellValue(rowIndex, colIndex, e.target.value)}
                            size="small"
                            fullWidth
                            helperText={
                              mergeInfo
                                ? `Merged cell (${mergeInfo.merge.rowEnd - mergeInfo.merge.rowStart + 1}×${mergeInfo.merge.colEnd - mergeInfo.merge.colStart + 1})`
                                : undefined
                            }
                            sx={{
                              flex: 1,
                              '& .MuiInputBase-input': {
                                bgcolor: mergeInfo ? 'blue.50' : 'transparent',
                              },
                            }}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => openCellStyleDialog('thead', rowIndex, colIndex)}
                            sx={{ minWidth: '40px', p: 0.5, height: '40px' }}
                            title="Cell Style"
                          >
                            🎨
                          </Button>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            ))}
          </Box>

          {!autoPopulateEnabled && (
            <>
              <Divider sx={{ my: 2 }} />
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography type="s3" weight="medium" color="theme.secondary.1000">
                    Rows ({tableData.rows.length})
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => addRow()}
                    startIcon={<AddIcon />}
                    className='black-outlined-btn'
                  >
                    Add Row
                  </Button>
                </Box>


                {tableData.rows.map((row, rowIndex) => (
                  <Box key={rowIndex} sx={{ mb: 2, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Typography type="s4" weight="medium" color="theme.secondary.800">
                        Row {rowIndex + 1}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => removeRow(rowIndex)}
                        disabled={tableData.rows.length <= 1}
                        color="error"
                      >
                        <Trash />
                      </IconButton>
                    </Box>
                    <Grid container spacing={1}>

                      {tableData.columns.map((column, colIndex) => {
                        const hasPlaceholder = rowLevel ? rowPlaceholders[rowIndex]?.[column.id] : tPlaceholders?.[column.id];
                        const placeholderInfo = hasPlaceholder ? getPlaceholderInfo(tPlaceholders?.[column.id] || rowPlaceholders[rowIndex]?.[column.id]) : null;
                        const mergeInfo = getCellMergeInfo('tbody', rowIndex, colIndex);

                        return (
                          <Grid item xs={12} key={column.id}>

                            {rowLevel ? (
                              <>
                                <Typography type="s4" weight="medium" color="theme.secondary.800"> {column.header} </Typography>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: 1,
                                    width: '100%',
                                  }}
                                >
                                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <TextField
                                      value={customText[rowIndex]?.[column.id] || ''}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setCustomText(prev => {
                                          const updated = { ...prev };
                                          if (!updated[rowIndex]) {
                                            updated[rowIndex] = {};
                                          }
                                          updated[rowIndex][column.id] = newValue;
                                          return updated;
                                        });

                                        // Update table data on custom text change
                                        setTableData(prev => ({
                                          ...prev,
                                          rows: prev.rows.map((row, idx) =>
                                            idx === rowIndex
                                              ? {
                                                ...row,
                                                [`${column.id}_static`]: newValue
                                                  ? `${newValue} ${row[column.id] || ''}`.trim()
                                                  : '',
                                              }
                                              : row
                                          ),
                                        }));
                                      }}
                                      size="small"
                                      placeholder="Enter custom text..."
                                      fullWidth
                                    />
                                    <Box sx={{ width: '100%' }}>
                                      <SearchableSelect
                                        value={mergeInfo ? mergeInfo.merge.value : (rowPlaceholders[rowIndex]?.[column.id] || row[column.id] || '')}
                                        onChange={(e) => updateRowCellValue(rowIndex, column.id, e.target.value)}
                                        size="small"
                                        options={(placeholders || []).map((p: any) => ({
                                          value: p.value || p.id || p.field || p.key,
                                          label: p.label || p.id || p.field,
                                          description: p.description
                                        }))}
                                        // disabled={isUpdating}
                                        sx={{
                                          width: '100%',
                                          '& .MuiInputBase-input': {
                                            bgcolor:
                                              hasPlaceholder && autoPopulateEnabled
                                                ? 'grey.100'
                                                : mergeInfo
                                                  ? 'blue.50'
                                                  : 'transparent',
                                          },
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => openCellStyleDialog('tbody', rowIndex, column.id)}
                                    sx={{ minWidth: '40px', p: 0.5, alignSelf: 'flex-start', height: '40px' }}
                                    title="Cell Style"
                                  >
                                    🎨
                                  </Button>
                                </Box>
                              </>
                            ) : (
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                  label={column.header}
                                  value={mergeInfo ? mergeInfo.merge.value : (row[column.id] || '')}
                                  onChange={(e) => updateCellValue(rowIndex, column.id, e.target.value)}
                                  size="small"
                                  fullWidth
                                  disabled={autoPopulateEnabled || hasPlaceholder}
                                  helperText={
                                    mergeInfo
                                      ? `Merged cell (${mergeInfo.merge.rowEnd - mergeInfo.merge.rowStart + 1}×${mergeInfo.merge.colEnd - mergeInfo.merge.colStart + 1})`
                                      : hasPlaceholder && placeholderInfo
                                        ? `Linked to: ${placeholderInfo.label}`
                                        : undefined
                                  }
                                  sx={{
                                    flex: 1,
                                    '& .MuiInputBase-input': {
                                      bgcolor:
                                        hasPlaceholder && autoPopulateEnabled
                                          ? 'grey.100'
                                          : mergeInfo
                                            ? 'blue.50'
                                            : 'transparent',
                                    },
                                  }}
                                />
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => openCellStyleDialog('tbody', rowIndex, column.id)}
                                  sx={{ minWidth: '40px', p: 0.5, alignSelf: 'flex-start', height: '40px' }}
                                  title="Cell Style"
                                >
                                  🎨
                                </Button>
                              </Box>
                            )}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                ))}
              </Box>
            </>
          )}

          {autoPopulateEnabled && !rowLevel && (
            <>
              <Divider sx={{ my: 2 }} />

              <Typography type="s3" weight="medium" color="theme.secondary.1000" sx={{ mb: 1 }}>
                Column Data Sources
              </Typography>



              {placeholders.length === 0 && (
                <Alert severity="info" sx={{ mb: 2 }}>
                  No placeholders available. Add placeholders to dynamically populate table data.
                </Alert>
              )}

              <Grid container spacing={1} alignItems='center'>
                {tableData.columns.map((column) => {
                  const currentPlaceholder = tPlaceholders?.[column.id] || tableData.rows?.[0]?.[column.id];

                  const placeholderInfo = currentPlaceholder ? getPlaceholderInfo(currentPlaceholder) : null;

                  return (
                    <React.Fragment key={column.id}>
                      <Grid item xs={4}>
                        <Typography type="s5" weight="medium" color="theme.secondary.800">
                          {column.header}
                        </Typography>
                        {placeholderInfo && (
                          <Typography type="s6" color="theme.secondary.600" sx={{ fontStyle: 'italic' }}>
                            {placeholderInfo.type}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={8}>
                        <SearchableSelect
                          value={rowLevel ? '' : (currentPlaceholder || '')}
                          onChange={(e) => {
                            updateColumnPlaceholder(column.id, e.target.value as string)
                          }}
                          size="small"
                          options={tableAttributes.map((attr: any) => ({
                            value: attr.value || attr.id || attr.field || attr.key,
                            label: attr.label || attr.id || attr.field,
                            // Include description if available in your tableAttributes
                            description: attr.description
                          }))}
                          disabled={isUpdating || rowLevel}
                          sx={{
                            flex: 1,
                            maxWidth: 150,
                            minWidth: 150,
                            '& .MuiInputBase-input': {
                              bgcolor: 'transparent',
                              width: 150,
                            },
                          }}
                          renderOption={(props, option) => (
                            <MenuItem {...props} key={option.value}>
                              <Box>
                                <Typography type="s5" color="theme.secondary.1000">
                                  {option.label}
                                </Typography>
                                {option.description && (
                                  <Typography type="s6" color="theme.secondary.600" sx={{ fontStyle: 'italic' }}>
                                    {option.description}
                                  </Typography>
                                )}
                              </Box>
                            </MenuItem>
                          )}
                          noOptionsText={
                            <MenuItem disabled>
                              <Typography type="s5" color="theme.secondary.600">
                                No Data Source
                              </Typography>
                            </MenuItem>
                          }
                        />
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
            </>
          )}
        </>
      )}

      {tabValue === 1 && (
        <Box sx={{
          '& >:first-child': { borderTopLeftRadius: 8, borderTopRightRadius: 8 },
          '& >:last-child': { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }
        }}>
          <Accordion
            expanded={expanded === 'tableBasic'}
            onChange={handleAccordionChange('tableBasic')}
            disableGutters
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography type='s3' color='theme.secondary.1000'>Table Basic Properties</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <BorderControl
                styles={tableStyles}
                onChange={(key, value) => updateTableStyle(key, value)}
                isBordered={tableStyles.is_bordered}
              />
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                  <Typography type='s5' weight='medium' color='theme.secondary.800' variant="caption">
                    Table Opacity
                  </Typography>
                  <Typography type='s5' color='theme.secondary.600' variant="caption">
                    {typeof tableStyles?.opacity === 'number' ? Math.round(tableStyles.opacity * 100) : 100}%
                  </Typography>
                </Box>
                <Slider
                  value={typeof tableStyles?.opacity === 'number' ? Math.round(tableStyles.opacity * 100) : 100}
                  min={0}
                  max={100}
                  step={1}
                  size="small"
                  onChange={(_, value) => updateTableStyle('opacity', (value as number) / 100)}
                  valueLabelDisplay="auto"
                  sx={(theme: any) => ({
                    '& .MuiSlider-rail': {
                      color: theme.palette.theme?.primary?.[500] || '#6366f1',
                    },
                    '& .MuiSlider-thumb': {
                      color: theme.palette.theme?.primary?.[800] || '#4338ca',
                    },
                    '& .MuiSlider-track': {
                      color: theme.palette.theme?.primary?.[600] || '#4f46e5',
                    },
                  })}
                />
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === 'tableHeader'}
            onChange={handleAccordionChange('tableHeader')}
            disableGutters
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography type='s3' color='theme.secondary.1000'>Table Header Styles</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ColorPickerInput
                    value={tableStyles.tHead?.backgroundColor ?? 'rgba(245, 245, 245, 0.75)'}
                    onChange={(color) => updateHeaderStyle('backgroundColor', color)}
                    fullWidth
                    label='Background Color'
                  />
                </Grid>

                <Grid item xs={12}>
                  <ColorPickerInput
                    value={tableStyles.tHead?.color || '#333333'}
                    onChange={(color) => updateHeaderStyle('color', color)}
                    fullWidth
                    label='Text Color'
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Font Size'
                    type='number'
                    value={tableStyles.tHead?.fontSize ?? 14}
                    onChange={(e) => updateHeaderStyle('fontSize', e.target.value === '' ? 14 : parseInt(e.target.value))}
                    size='small'
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <Select
                    value={tableStyles.tHead?.fontWeight || 'bold'}
                    onChange={(e) => updateHeaderStyle('fontWeight', e.target.value)}
                    fullWidth
                    size='small'
                    label='Font Weight'
                  >
                    {fontWeightOptions.map(weight => (
                      <MenuItem key={weight} value={weight}>
                        {formatText(weight)}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12}>
                  <Select
                    value={tableStyles.tHead?.fontFamily || 'Arial, sans-serif'}
                    onChange={(e) => updateHeaderStyle('fontFamily', e.target.value)}
                    fullWidth
                    size='small'
                    label='Font Family'
                  >
                    {fontFamilyOptions.map(font => (
                      <MenuItem key={font} value={font}>
                        {font.split(',')[0]}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={6}>
                  <Select
                    value={tableStyles.tHead?.textAlign || 'left'}
                    onChange={(e) => updateHeaderStyle('textAlign', e.target.value)}
                    fullWidth
                    size='small'
                    label='Text Align'
                  >
                    {textAlignOptions.map(align => (
                      <MenuItem key={align} value={align}>
                        {formatText(align)}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Cell Padding'
                    type='number'
                    value={tableStyles.thCells?.padding ?? 8}
                    onChange={(e) => updateHeaderCellStyle('padding', e.target.value === '' ? 8 : parseInt(e.target.value))}
                    size='small'
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Header Height (px)'
                    type='number'
                    value={tableStyles.tHead?.rowHeight ?? ''}
                    onChange={(e) => updateHeaderStyle('rowHeight', e.target.value === '' ? '' : Math.max(1, parseInt(e.target.value)))}
                    size='small'
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Android12Switch
                        checked={!!tableStyles.tBody?.zebraStriping}
                        onChange={(e) => updateBodyStyle('zebraStriping', e.target.checked)}
                      />
                    }
                    label="Zebra Striping"
                  />
                </Grid>

                {tableStyles.tBody?.zebraStriping && (
                  <Grid item xs={12}>
                    <Typography type='s5' weight='medium' color='theme.secondary.1000' variant="caption">Alternating Row Color</Typography>
                    <ColorPickerInput
                      value={tableStyles.tBody?.alternateRowColor || '#f9f9f9'}
                      onChange={(color) => updateBodyStyle('alternateRowColor', color)}
                      fullWidth
                    />
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === 'tableBody'}
            onChange={handleAccordionChange('tableBody')}
            disableGutters
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography type='s3' color='theme.secondary.1000'>Table Body Styles</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ColorPickerInput
                    value={tableStyles.tBody?.backgroundColor ?? 'rgba(255, 255, 255, 0.75)'}
                    onChange={(color) => updateBodyStyle('backgroundColor', color)}
                    fullWidth
                    label='Background Color'
                  />
                </Grid>

                <Grid item xs={12}>
                  <ColorPickerInput
                    value={tableStyles.tBody?.color || '#333333'}
                    onChange={(color) => updateBodyStyle('color', color)}
                    fullWidth
                    label='Text Color'
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Font Size'
                    type='number'
                    value={tableStyles.tBody?.fontSize ?? 14}
                    onChange={(e) => updateBodyStyle('fontSize', e.target.value === '' ? 14 : parseInt(e.target.value))}
                    size='small'
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <Select
                    value={tableStyles.tBody?.fontWeight || 'normal'}
                    onChange={(e) => updateBodyStyle('fontWeight', e.target.value)}
                    fullWidth
                    size='small'
                    label='Font Weight'
                  >
                    {fontWeightOptions.map(weight => (
                      <MenuItem key={weight} value={weight}>
                        {formatText(weight)}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12}>
                  <Select
                    value={tableStyles.tBody?.fontFamily || 'Arial, sans-serif'}
                    onChange={(e) => updateBodyStyle('fontFamily', e.target.value)}
                    fullWidth
                    size='small'
                    label='Font Family'
                  >
                    {fontFamilyOptions.map(font => (
                      <MenuItem key={font} value={font}>
                        {font.split(',')[0]}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={6}>
                  <Select
                    value={tableStyles.tBody?.textAlign || 'left'}
                    onChange={(e) => updateBodyStyle('textAlign', e.target.value)}
                    fullWidth
                    size='small'
                    label='Text Align'
                  >
                    {textAlignOptions.map(align => (
                      <MenuItem key={align} value={align}>
                        {formatText(align)}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Cell Padding'
                    type='number'
                    value={tableStyles.tbCells?.padding ?? 8}
                    onChange={(e) => updateBodyCellStyle('padding', e.target.value === '' ? 8 : parseInt(e.target.value))}
                    size='small'
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Row Height (px)'
                    type='number'
                    value={tableStyles.tBody?.rowHeight ?? ''}
                    onChange={(e) => updateBodyStyle('rowHeight', e.target.value === '' ? '' : Math.max(1, parseInt(e.target.value)))}
                    size='small'
                    fullWidth
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>
      )}

      {tabValue === 2 && (
        <Box>
          <Box sx={{ mb: 3 }}>
            <Typography type="s3" weight="medium" color="theme.secondary.1000" sx={{ mb: 2 }}>
              Cell Selection & Merging
            </Typography>

            <Alert severity="info" sx={{ mb: 2 }}>
              Click on cells in the table below to select them for merging. Selected cells will be highlighted. You can merge cells within the header or body, but not across both.
              <br/><strong>Tip:</strong> You can select cells across multiple rows to create vertical merges (rowspan)!
            </Alert>

            <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="small"
                onClick={openMergeDialog}
                startIcon={<MergeIcon />}
                disabled={selectedCells.length < 2}
                color="primary"
              >
                Merge Selected ({selectedCells.length})
              </Button>

              <Button
                variant="outlined"
                size="small"
                onClick={() => setSelectedCells([])}
                disabled={selectedCells.length === 0}
                className='black-outlined-btn'
              >
                Clear Selection
              </Button>
            </Box>

            <Box sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              overflow: 'auto',
              maxHeight: 400
            }}>
              <Table size="small" sx={{ minWidth: 300 }}>
                <TableHead>
                  {(tableData.headerRows && tableData.headerRows.length > 0
                    ? tableData.headerRows
                    : [{ id: 'default', cells: tableData.columns.map(c => ({ id: c.id, value: c.header })) }]
                  ).map((hRow, rowIndex) => (
                    <TableRow key={hRow.id}>
                      {hRow.cells.map((cell, colIndex) => {
                        const mergeInfo = getCellMergeInfo('thead', rowIndex, colIndex);
                        const isSelected = isCellSelected('thead', rowIndex, colIndex);

                        if (mergeInfo?.isCovered) {
                          return null;
                        }

                        const cellContent = mergeInfo ? mergeInfo.merge.value : cell.value;
                        const rowSpan = mergeInfo ? mergeInfo.merge.rowEnd - mergeInfo.merge.rowStart + 1 : 1;
                        const colSpan = mergeInfo ? mergeInfo.merge.colEnd - mergeInfo.merge.colStart + 1 : 1;

                        return (
                          <TableCell
                            key={cell.id}
                            rowSpan={rowSpan}
                            colSpan={colSpan}
                            onClick={() => !mergeInfo && toggleCellSelection('thead', rowIndex, colIndex)}
                            sx={(theme) => ({
                              fontWeight: 'bold',
                              bgcolor: mergeInfo ? 'blue.50' :
                                isSelected ? 'primary.100' : 'grey.100',
                              position: 'sticky',
                              top: 0,
                              zIndex: 1,
                              cursor: mergeInfo ? 'default' : 'pointer',
                              border: isSelected ? 2 : 1,
                              borderColor: isSelected ? theme.palette.theme.primary[800] : 'divider',
                              '&:hover': mergeInfo ? {} : {
                                bgcolor: isSelected ? 'primary.200' : 'grey.50'
                              }
                            })}
                          >
                            {cellContent}
                            {mergeInfo && (
                              <Chip
                                label={`${rowSpan}×${colSpan}`}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={(theme) => ({
                                  position: 'absolute',
                                  top: 2,
                                  right: 2,
                                  fontSize: '0.6rem',
                                  height: 16,
                                  color: theme.palette.theme.primary[800],
                                  borderColor: theme.palette.theme.primary[800]
                                })}
                              />
                            )}
                            {isSelected && (
                              <Checkbox
                                checked={true}
                                size="small"
                                sx={{
                                  position: 'absolute',
                                  top: 2,
                                  left: 2,
                                  padding: 0
                                }}
                              />
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {tableData.rows.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {tableData.columns.map((column, colIndex) => {
                        const mergeInfo = getCellMergeInfo('tbody', rowIndex, colIndex);
                        const isSelected = isCellSelected('tbody', rowIndex, colIndex);

                        if (mergeInfo?.isCovered) {
                          return null;
                        }

                        // Get customText for the cell
                        const customTextValue = customText[rowIndex]?.[column.id] || '';
                        // Combine customText with cell value or merge value
                        const cellContent = mergeInfo
                          ? mergeInfo.merge.value // Already includes customText from mergeCells
                          : customTextValue
                            ? `${customTextValue} ${row[column.id] || ''}`.trim()
                            : row[column.id] || '';

                        const rowSpan = mergeInfo ? mergeInfo.merge.rowEnd - mergeInfo.merge.rowStart + 1 : 1;
                        const colSpan = mergeInfo ? mergeInfo.merge.colEnd - mergeInfo.merge.colStart + 1 : 1;

                        return (
                          <TableCell
                            key={column.id}
                            rowSpan={rowSpan}
                            colSpan={colSpan}
                            onClick={() => !mergeInfo && toggleCellSelection('tbody', rowIndex, colIndex)}
                            sx={(theme) => ({
                              cursor: mergeInfo ? 'default' : 'pointer',
                              bgcolor: mergeInfo ? 'blue.50' :
                                isSelected ? 'primary.100' :
                                  'transparent',
                              border: isSelected ? 2 : 1,
                              borderColor: isSelected ? theme.palette.theme?.primary[800] : 'divider',
                              '&:hover': mergeInfo ? {} : {
                                bgcolor: isSelected ? 'primary.200' : 'grey.50'
                              },
                              position: 'relative'
                            })}
                          >
                            {cellContent}
                            {mergeInfo && (
                              <Chip
                                label={`${rowSpan}×${colSpan}`}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={(theme) => ({
                                  position: 'absolute',
                                  top: 2,
                                  right: 2,
                                  fontSize: '0.6rem',
                                  height: 16,
                                  color: theme.palette.theme?.primary[800],
                                  borderColor: theme.palette.theme?.primary[800]
                                })}
                              />
                            )}
                            {isSelected && (
                              <Checkbox
                                checked={true}
                                size="small"
                                sx={{
                                  position: 'absolute',
                                  top: 2,
                                  left: 2,
                                  padding: 0
                                }}
                              />
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>

          {mergedCells.length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Typography type="s3" weight="medium" color="theme.secondary.1000" sx={{ mb: 2 }}>
                Merged Cells ({mergedCells.length})
              </Typography>

              {mergedCells.map((merge, index) => (
                <Box
                  key={index}
                  sx={{
                    p: 2,
                    mb: 1,
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: 'blue.25'
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Box>
                      <Typography type="s4" weight="medium" color="theme.secondary.900">
                        Merge {index + 1}: {merge.rowEnd - merge.rowStart + 1}×{merge.colEnd - merge.colStart + 1} cells ({merge.section})
                      </Typography>
                      <Typography type="s5" color="theme.secondary.700">
                        Rows {merge.rowStart + 1}-{merge.rowEnd + 1}, Columns {merge.colStart + 1}-{merge.colEnd + 1}
                      </Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => splitMergedCell(index)}
                      startIcon={<SplitIcon />}
                      className='black-outlined-btn'
                    >
                      Split
                    </Button>
                  </Box>

                  <TextField
                    label="Merged Cell Value"
                    value={merge.value}
                    onChange={(e) => {
                      setTableData(prev => ({
                        ...prev,
                        mergedCells: prev.mergedCells?.map((m, i) =>
                          i === index ? { ...m, value: e.target.value } : m
                        ) || []
                      }));
                    }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      )}

      <Dialog
        open={mergeDialogOpen}
        onClose={() => setMergeDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography type="s2" weight="medium">
            Merge Selected Cells
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography type="s4" color="theme.secondary.700" sx={{ mb: 2 }}>
            You are about to merge {selectedCells.length} selected cells in {selectedCells[0]?.section}.
            Enter the value for the merged cell:
          </Typography>

          <TextField
            label="Merged Cell Value"
            value={mergeValue}
            onChange={(e) => setMergeValue(e.target.value)}
            fullWidth
            multiline
            rows={3}
            sx={{ mt: 1 }}
          />

          <Alert severity="info" sx={{ mt: 2 }}>
            The merged cell will span from row {Math.min(...selectedCells.map(c => c.row)) + 1} to {Math.max(...selectedCells.map(c => c.row)) + 1}
            and column {Math.min(...selectedCells.map(c => c.col)) + 1} to {Math.max(...selectedCells.map(c => c.col)) + 1} in {selectedCells[0]?.section}.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMergeDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={mergeCells}
            variant="contained"
            color="primary"
          >
            Merge Cells
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={cellStyleDialogOpen}
        onClose={() => {
          setCellStyleDialogOpen(false);
          setEditingCellStyle(null);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography type="s2" weight="medium">
            Edit Cell Style
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                label="Cell Text (Context)"
                value={editingCellText}
                disabled
                fullWidth
                size="small"
                sx={{ bgcolor: 'grey.50' }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Width (e.g. 100px, 20%)"
                value={tempCellStyle.width as string || ''}
                onChange={(e) => setTempCellStyle(prev => ({ ...prev, width: e.target.value }))}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <ColorPickerInput
                value={tempCellStyle.backgroundColor as string || inheritedBg}
                onChange={(color) => setTempCellStyle(prev => ({ ...prev, backgroundColor: color }))}
                fullWidth
                label='Background Color'
              />
            </Grid>
            <Grid item xs={12}>
              <ColorPickerInput
                value={tempCellStyle.color as string || inheritedColor}
                onChange={(color) => setTempCellStyle(prev => ({ ...prev, color }))}
                fullWidth
                label='Text Color'
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                label='Text Direction'
                value={tempCellStyle.direction as string || ''}
                onChange={(e) => setTempCellStyle(prev => ({ ...prev, direction: e.target.value as any }))}
                fullWidth
                size="small"
                displayEmpty
              >
                <MenuItem value="">Default ({inheritedDirection.toUpperCase()})</MenuItem>
                <MenuItem value="ltr">LTR (Left to Right)</MenuItem>
                <MenuItem value="rtl">RTL (Right to Left)</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Select
                label='Text Align'
                value={tempCellStyle.textAlign as string || ''}
                onChange={(e) => setTempCellStyle(prev => ({ ...prev, textAlign: e.target.value as any }))}
                fullWidth
                size="small"
                displayEmpty
              >
                <MenuItem value="">Default ({inheritedAlign})</MenuItem>
                <MenuItem value="left">Left</MenuItem>
                <MenuItem value="center">Center</MenuItem>
                <MenuItem value="right">Right</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Select
                label='Font Weight'
                value={tempCellStyle.fontWeight as string || ''}
                onChange={(e) => setTempCellStyle(prev => ({ ...prev, fontWeight: e.target.value as any }))}
                fullWidth
                size="small"
                displayEmpty
              >
                <MenuItem value="">Default ({inheritedFontWeight})</MenuItem>
                {fontWeightOptions.map(weight => (
                  <MenuItem key={weight} value={weight}>{formatText(weight)}</MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setCellStyleDialogOpen(false);
            setEditingCellStyle(null);
          }}>
            Cancel
          </Button>
          <Button
            onClick={saveCellStyle}
            variant="contained"
            color="primary"
          >
            Apply Style
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TableControls;